// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalClaimModel {
    static getAttributeTypeMap() {
        return MedicalClaimModel.attributeTypeMap;
    }
}
MedicalClaimModel.discriminator = undefined;
MedicalClaimModel.additionalProperties = false;
MedicalClaimModel.attributeTypeMap = [
    {
        "name": "claimId",
        "baseName": "claimId",
        "type": "number"
    },
    {
        "name": "createdBy",
        "baseName": "createdBy",
        "type": "number"
    },
    {
        "name": "updatedBy",
        "baseName": "updatedBy",
        "type": "number"
    },
    {
        "name": "promotionGroupNumber",
        "baseName": "promotionGroupNumber",
        "type": "string"
    },
    {
        "name": "isTestBatch",
        "baseName": "isTestBatch",
        "type": "boolean"
    },
    {
        "name": "paymentMethodTypeId",
        "baseName": "paymentMethodTypeId",
        "type": "number"
    },
    {
        "name": "conditions",
        "baseName": "conditions",
        "type": ""
    },
    {
        "name": "substatus",
        "baseName": "substatus",
        "type": "string"
    },
    {
        "name": "providers",
        "baseName": "providers",
        "type": ""
    },
    {
        "name": "payors",
        "baseName": "payors",
        "type": ""
    },
    {
        "name": "isMigrated",
        "baseName": "isMigrated",
        "type": "boolean"
    },
    {
        "name": "eobId",
        "baseName": "eobId",
        "type": "number"
    },
    {
        "name": "claimGroupId",
        "baseName": "claimGroupId",
        "type": "number"
    },
    {
        "name": "classTypeId",
        "baseName": "classTypeId",
        "type": "number"
    },
    {
        "name": "generalCoverageTypeId",
        "baseName": "generalCoverageTypeId",
        "type": "number"
    },
    {
        "name": "financialTransactionTypeId",
        "baseName": "financialTransactionTypeId",
        "type": "number"
    },
    {
        "name": "transactionTypeId",
        "baseName": "transactionTypeId",
        "type": "number"
    },
    {
        "name": "billedAmount",
        "baseName": "billedAmount",
        "type": "number"
    },
    {
        "name": "chargesDiscountedAmount",
        "baseName": "chargesDiscountedAmount",
        "type": "number"
    },
    {
        "name": "coveredAmount",
        "baseName": "coveredAmount",
        "type": "number"
    },
    {
        "name": "deductibleAppliedAmount",
        "baseName": "deductibleAppliedAmount",
        "type": "number"
    },
    {
        "name": "copayAmount",
        "baseName": "copayAmount",
        "type": "number"
    },
    {
        "name": "cobAmount",
        "baseName": "cobAmount",
        "type": "number"
    },
    {
        "name": "paidAmount",
        "baseName": "paidAmount",
        "type": "number"
    },
    {
        "name": "causeTypeId",
        "baseName": "causeTypeId",
        "type": "number"
    },
    {
        "name": "procedureTypeId",
        "baseName": "procedureTypeId",
        "type": "number"
    },
    {
        "name": "modifierTypeId",
        "baseName": "modifierTypeId",
        "type": "number"
    },
    {
        "name": "ndcId",
        "baseName": "ndcId",
        "type": "number"
    },
    {
        "name": "ndc",
        "baseName": "ndc",
        "type": "string"
    },
    {
        "name": "ndcQuantity",
        "baseName": "ndcQuantity",
        "type": "number"
    },
    {
        "name": "ndcUnit",
        "baseName": "ndcUnit",
        "type": "string"
    },
    {
        "name": "assignmentFlag",
        "baseName": "assignmentFlag",
        "type": "boolean"
    },
    {
        "name": "serviceStartDate",
        "baseName": "serviceStartDate",
        "type": "Date"
    },
    {
        "name": "serviceEndDate",
        "baseName": "serviceEndDate",
        "type": "Date"
    },
    {
        "name": "originalLossDate",
        "baseName": "originalLossDate",
        "type": "Date"
    },
    {
        "name": "claimReceivedDate",
        "baseName": "claimReceivedDate",
        "type": "Date"
    },
    {
        "name": "claimAdjudicatedDate",
        "baseName": "claimAdjudicatedDate",
        "type": "Date"
    },
    {
        "name": "placeOfServiceTypeId",
        "baseName": "placeOfServiceTypeId",
        "type": "number"
    },
    {
        "name": "serviceTypeId",
        "baseName": "serviceTypeId",
        "type": "number"
    },
    {
        "name": "networkFlag",
        "baseName": "networkFlag",
        "type": "boolean"
    },
    {
        "name": "serviceCount",
        "baseName": "serviceCount",
        "type": "number"
    },
    {
        "name": "unitCount",
        "baseName": "unitCount",
        "type": "number"
    },
    {
        "name": "checkDate",
        "baseName": "checkDate",
        "type": "Date"
    },
    {
        "name": "checkNumber",
        "baseName": "checkNumber",
        "type": "number"
    },
    {
        "name": "abfEobNumber",
        "baseName": "abfEobNumber",
        "type": "string"
    },
    {
        "name": "abfCheckNumber",
        "baseName": "abfCheckNumber",
        "type": "string"
    },
    {
        "name": "ub82BillType",
        "baseName": "ub82BillType",
        "type": "string"
    },
    {
        "name": "billType",
        "baseName": "billType",
        "type": "string"
    },
    {
        "name": "revenueCode",
        "baseName": "revenueCode",
        "type": "string"
    },
    {
        "name": "admissionDate",
        "baseName": "admissionDate",
        "type": "Date"
    },
    {
        "name": "dischargeDate",
        "baseName": "dischargeDate",
        "type": "Date"
    },
    {
        "name": "notCoveredAmount",
        "baseName": "notCoveredAmount",
        "type": "number"
    },
    {
        "name": "outOfPocketAmount",
        "baseName": "outOfPocketAmount",
        "type": "number"
    },
    {
        "name": "ineligibleAmount",
        "baseName": "ineligibleAmount",
        "type": "number"
    },
    {
        "name": "otherInsurancePaidAmount",
        "baseName": "otherInsurancePaidAmount",
        "type": "number"
    },
    {
        "name": "allowedAmount",
        "baseName": "allowedAmount",
        "type": "number"
    },
    {
        "name": "ndcUnitPriceAmount",
        "baseName": "ndcUnitPriceAmount",
        "type": "number"
    },
    {
        "name": "eobAdjudicationCodeIds",
        "baseName": "eobAdjudicationCodeIds",
        "type": ""
    },
    {
        "name": "providerIds",
        "baseName": "providerIds",
        "type": ""
    },
    {
        "name": "diagnosisIds",
        "baseName": "diagnosisIds",
        "type": ""
    },
    {
        "name": "adjudicationCodes",
        "baseName": "adjudicationCodes",
        "type": ""
    },
    {
        "name": "parentClaimId",
        "baseName": "parentClaimId",
        "type": "number"
    },
    {
        "name": "claimTypeId",
        "baseName": "claimTypeId",
        "type": "number"
    },
    {
        "name": "patientLastName",
        "baseName": "patientLastName",
        "type": "string"
    },
    {
        "name": "patientFirstName",
        "baseName": "patientFirstName",
        "type": "string"
    },
    {
        "name": "patientDateOfBirth",
        "baseName": "patientDateOfBirth",
        "type": "Date"
    },
    {
        "name": "patientSex",
        "baseName": "patientSex",
        "type": "string"
    },
    {
        "name": "patientAddress",
        "baseName": "patientAddress",
        "type": "string"
    },
    {
        "name": "patientCity",
        "baseName": "patientCity",
        "type": "string"
    },
    {
        "name": "patientState",
        "baseName": "patientState",
        "type": "string"
    },
    {
        "name": "patientZip",
        "baseName": "patientZip",
        "type": "string"
    },
    {
        "name": "patientPhoneNumber",
        "baseName": "patientPhoneNumber",
        "type": "string"
    },
    {
        "name": "patientRelationshipTypeId",
        "baseName": "patientRelationshipTypeId",
        "type": "number"
    },
    {
        "name": "patientExternalReferences",
        "baseName": "patientExternalReferences",
        "type": ""
    },
    {
        "name": "processorId",
        "baseName": "processorId",
        "type": "number"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
    {
        "name": "dateProcessed",
        "baseName": "dateProcessed",
        "type": "Date"
    },
    {
        "name": "processedBy",
        "baseName": "processedBy",
        "type": "number"
    },
    {
        "name": "transactionBatchNumber",
        "baseName": "transactionBatchNumber",
        "type": "string"
    },
    {
        "name": "transactionNumber",
        "baseName": "transactionNumber",
        "type": "string"
    },
    {
        "name": "processorSponsorNumber",
        "baseName": "processorSponsorNumber",
        "type": "string"
    },
    {
        "name": "processorGroupNumber",
        "baseName": "processorGroupNumber",
        "type": "string"
    },
    {
        "name": "parClientNumber",
        "baseName": "parClientNumber",
        "type": "string"
    },
    {
        "name": "locationNumber",
        "baseName": "locationNumber",
        "type": "string"
    },
    {
        "name": "externalStatus",
        "baseName": "externalStatus",
        "type": "string"
    },
    {
        "name": "exceptionTypeIds",
        "baseName": "exceptionTypeIds",
        "type": ""
    },
    {
        "name": "overrideTypeIds",
        "baseName": "overrideTypeIds",
        "type": ""
    },
    {
        "name": "externalReferences",
        "baseName": "externalReferences",
        "type": ""
    },
    {
        "name": "promotionId",
        "baseName": "promotionId",
        "type": "number"
    },
    {
        "name": "claimStatusId",
        "baseName": "claimStatusId",
        "type": "number"
    },
    {
        "name": "requestedPaymentMethodTypeId",
        "baseName": "requestedPaymentMethodTypeId",
        "type": "number"
    },
    {
        "name": "benefitPaid",
        "baseName": "benefitPaid",
        "type": "number"
    },
    {
        "name": "remainingCost",
        "baseName": "remainingCost",
        "type": "number"
    },
    {
        "name": "rejectTypeIds",
        "baseName": "rejectTypeIds",
        "type": ""
    },
];
//# sourceMappingURL=medicalClaimModel.js.map